module.exports = __webpack_public_path__ + "static/img/company.5dabb221.png";